import {getCurrentLanguageEnum} from "../../@types/generics.tsx";
import {Section} from "../../@types/privacyPolicySectionResources.tsx";
import {useTranslation} from "react-i18next";
import LegalPageNumericListItem from "./LegalPageNumericListItem.tsx";
import './NumericListStyles.scss';
import LegalPageSectionParagraphTransComponent
    from "../legal-pages-components/LegalPageSectionParagraphTransComponent.tsx";

const LegalPageNumericList = ({section, locale}: {section: Section, locale?: string}) => {

    const {i18n} = locale ? useTranslation('translation', {lng: locale}) : useTranslation();
    const currentLanguage = getCurrentLanguageEnum(i18n.language);

    return (
        <>
            {
                section.languageToShow.includes(getCurrentLanguageEnum(i18n.language))
                    ?
                    <>
                        <li className="fs-6 mb-3 text-blue-dark">
                        {section.heading && <>
                            <LegalPageSectionParagraphTransComponent text={section.heading} locale={locale}/>
                            <ol className="fs-8 mt-4">
                                {section.paragraphs.map((paragraph, index) => (
                                    section.languageToShow.includes(currentLanguage)
                                        && paragraph.languageToShow.includes(currentLanguage)
                                            ? <LegalPageNumericListItem key={index} paragraph={paragraph} locale={locale}/>
                                            : null
                                ))}
                            </ol>
                        </>}
                        </li>
                    </>
                    : null
            }
        </>
    )
}

export default LegalPageNumericList;
